import React from 'react';
import Watermark from '../Watermark';
import styles from './index.module.scss';
import { useSelector } from 'react-redux';
import { getBrandDisabledState } from '../../store/selectors';
import MobileWatermark from '../MobileWatermark';
import { useDeviceType } from '../../hooks/use-device-type';

function AppWatermark() {
  const disabledBranding = useSelector(getBrandDisabledState);
  const deviceType = useDeviceType();
  const isMobile = deviceType !== 'desktop';

  if (disabledBranding) {
    return null;
  }
  return (
    <div className={styles.container}>
      {isMobile ? <MobileWatermark /> : <Watermark />}
    </div>
  );
}

export default AppWatermark;
